import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { aiSessionContextPluginKey } from '../../ai-session-context/ai-session-context-plugin-key';
import { createEndAIExperienceCommand } from '../actions';
import { getPluginState } from '../decoration-plugin-factory';
import { hasGeneratedContentDecorations } from './hasGeneratedContentDecorations';

export const onClearGeneratedContentDecorator = (view: EditorView, event: Event): boolean => {
	const pluginState = getPluginState(view.state);

	// [CCI-15904] When the Post Stream Review modal is open we *want* the
	// AI-generated content decorations to stay around — the modal is anchored to
	// them. Without this guard, every click on a toolbar button (Undo, Redo, Ask
	// Rovo, Take to Staging, etc.) would dispatch endAIExperience and tear the
	// modal down before the button's onClick had a chance to run.
	const sessionState = aiSessionContextPluginKey.getState(view.state);
	if (sessionState?.status === 'postStreamReview') {
		return false;
	}

	if (hasGeneratedContentDecorations(pluginState)) {
		const endAIExperienceCommand = createEndAIExperienceCommand();
		endAIExperienceCommand(view.state, view.dispatch);

		return true;
	}
	return false;
};
